import React from "react";

const CenterSticky = () => (
  <div className="tooltip tooltip--center-sticky-view">
    <p className="tooltip__text" />
  </div>
);

export default CenterSticky;
